import { UseActionExecuteType } from '@/models/action_base';
import { Common } from '@/models/common';
import { TieUp } from '@/models/tie_up';
import RouterConst from '@/router/router_const';

import { useRouting } from './use_routing';
import { useState } from './use_state';

const findKeyAndValueIgnoreCase = (key: string, query: Record<string, any>) => {
  const lowerKey = key.toLowerCase();
  const actualKey = Object.keys(query).find((k) => k.toLowerCase() === lowerKey);

  if (actualKey !== undefined) {
    return { exists: true,
      value: query[actualKey] };
  } else {
    return { exists: false,
      value: undefined };
  }
};

const findTieUp = (common: { tieUp?: TieUp[] }, key: string): TieUp | undefined => {
  if (!common?.tieUp) {
    return undefined;
  }
  return common.tieUp.find(tieUp => tieUp.id === key);
};

/**
 * クエリを解釈してページ遷移する
 * 遷移という言葉であるが、送信用データの解釈と保存も行う
 */
export function useActionQueryTransition(): UseActionExecuteType {

  const routing = useRouting();
  const stateData = useState();

  return async () => {

    const parsedData = JSON.parse(stateData.value.common);
    const common = new Common(parsedData);
    const query = routing.getQuery();

    // queryStringは別の用途で使用しているので別にqueryを送信しておく用に保持
    // 基本この呼び出しで上書きされ続けなければ残り、実際のURL上のクエリパラメータとして渡す。
    // アプリ内遷移でqueryが空の場合は更新しない。外部からの遷移はクエリパラメータを付けてもらう。
    const queryString = window.location.search;
    if (queryString) {
      stateData.value.query = queryString;
      const qrResult = findKeyAndValueIgnoreCase('qr', query);
      const lpResult = findKeyAndValueIgnoreCase('lp', query);
      const lineResult = findKeyAndValueIgnoreCase('line', query);

      // 流入経路について送信するデータを確定する
      if ([qrResult.exists, lpResult.exists, lineResult.exists].filter(Boolean).length > 1) {
        stateData.value.route = '複数指定';
      } else if (qrResult.exists) {
        stateData.value.route = 'QR';
      } else if (lpResult.exists) {
        stateData.value.route = 'LP';
      } else if (lineResult.exists) {
        stateData.value.route = 'LINE';
      } else {
        stateData.value.route = '指定無し';
      }

      //全店舗は細かくチェックする必要はないため、そのまま返却
      if (routing.isNationalPath()) {
        stateData.value.store = '全店舗';
        stateData.value.id = '';
        return false;
      }

      // タイアップ版は
      // 店舗について送信するデータを確定し、確定するのであればページ遷移する
      let tieUp = undefined;
      if ([qrResult.value, lpResult.value, lineResult.value].filter(Boolean).length > 1) {
        //フロー的にユーザーによる選択が行われ、書き換わる予定
        stateData.value.store = '複数指定により不明';
        stateData.value.id = '';
      } else if (qrResult.value) {
        tieUp = findTieUp(common, qrResult.value);
      } else if (lpResult.value) {
        tieUp = findTieUp(common, lpResult.value);
      } else if (lineResult.value) {
        tieUp = findTieUp(common, lineResult.value);
      } else {
        //フロー的にユーザーによる選択が行われ、書き換わる予定
        stateData.value.store = '指定無し';
        stateData.value.id = '';
      }

      //tieUpが決まっていれば遷移(店舗確認、または店舗期間外)
      if (tieUp) {
        stateData.value.store = tieUp.store || '';
        stateData.value.id = tieUp.id || '';
        stateData.value.shipping = tieUp.shipping || '';
        stateData.value.begin = tieUp.begin || '';
        stateData.value.end = tieUp.end || '';
        if (tieUp.enable) {
          await routing.redirect(RouterConst.TieUpStore);
        } else {
          await routing.redirect(RouterConst.TieUpOffHourStore);
        }
      }
    }
    return false;
  };
}
